"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShieldDefaultStep = void 0;
const step_1 = require("../step");
const fee_1 = require("../../utils/fee");
class ShieldDefaultStep extends step_1.Step {
    config = {
        name: 'Shield (Default)',
        description: 'Shield ERC20s and NFTs into private RAILGUN balance.',
    };
    canAddStep = false;
    async getStepOutput(input) {
        const { outputERC20Amounts, feeERC20AmountRecipients } = ShieldDefaultStep.getOutputERC20AmountsAndFees(input.networkName, input.erc20Amounts);
        if (!outputERC20Amounts.every(erc20Amount => !(erc20Amount.isBaseToken ?? false))) {
            throw new Error('Cannot shield base token.');
        }
        return {
            crossContractCalls: [],
            outputERC20Amounts,
            outputNFTs: input.nfts,
            feeERC20AmountRecipients,
        };
    }
    static getOutputERC20AmountsAndFees(networkName, inputERC20Amounts) {
        const outputERC20Amounts = [];
        const feeERC20AmountRecipients = [];
        inputERC20Amounts.forEach(erc20Amount => {
            const shieldFeeAmount = (0, fee_1.getShieldFee)(networkName, erc20Amount.expectedBalance);
            const shieldedAmount = (0, fee_1.getShieldedAmountAfterFee)(networkName, erc20Amount.expectedBalance);
            const shieldedAmountMinimum = (0, fee_1.getShieldedAmountAfterFee)(networkName, erc20Amount.minBalance);
            outputERC20Amounts.push({
                tokenAddress: erc20Amount.tokenAddress,
                decimals: erc20Amount.decimals,
                isBaseToken: erc20Amount.isBaseToken,
                approvedSpender: erc20Amount.approvedSpender,
                expectedBalance: shieldedAmount,
                minBalance: shieldedAmountMinimum,
                recipient: erc20Amount.recipient,
            });
            feeERC20AmountRecipients.push({
                tokenAddress: erc20Amount.tokenAddress,
                decimals: erc20Amount.decimals,
                amount: shieldFeeAmount,
                recipient: 'RAILGUN Shield Fee',
            });
        });
        if (!outputERC20Amounts.every(erc20Amount => !(erc20Amount.isBaseToken ?? false))) {
            throw new Error('Cannot shield base token.');
        }
        return { outputERC20Amounts, feeERC20AmountRecipients };
    }
}
exports.ShieldDefaultStep = ShieldDefaultStep;
